/**
 * Human-readable labels and helpers for notification display.
 */

const TYPE_LABELS = {
  general: "General update",
  follow: "New follower",
  "follow-request": "Follow request",
  comment: "Comment",
  review: "Review",
  tier_upgrade: "Tier upgrade",
  points_tier_upgrade: "Tier upgrade",
  points_milestone: "Points milestone",
  points_leaderboard: "Top contributor",
  error: "Alert",
  marketplace_approved: "Listing published",
  marketplace_pending: "Listing pending",
  marketplace_saved_search_match: "Saved search match",
  marketplace_message: "Marketplace message",
  marketplace_offer: "New offer",
  marketplace_offer_accepted: "Offer accepted",
  marketplace_offer_rejected: "Offer declined",
  marketplace_sold: "Listing sold",
  marketplace_saved_search_created: "Saved search created",
};

const CATEGORY_LABELS = {
  marketplace: "Marketplace",
  social: "Social",
  engagement: "Engagement",
  rewards: "Rewards",
  general: "General",
};

export const formatNotificationType = (type) => {
  if (!type) return "Update";
  if (TYPE_LABELS[type]) return TYPE_LABELS[type];
  return type
    .replace(/_/g, " ")
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const getNotificationCategory = (type) => {
  const t = (type || "").toLowerCase();
  if (t.startsWith("marketplace")) return "marketplace";
  if (t === "follow" || t === "follow-request") return "social";
  if (t === "comment" || t === "review") return "engagement";
  if (t === "tier_upgrade" || t === "points_tier_upgrade" || t === "points_milestone" || t === "points_leaderboard") return "rewards";
  return "general";
};

export const formatNotificationCategory = (type) => {
  return CATEGORY_LABELS[getNotificationCategory(type)] || "General";
};

export const isHighPriority = (priority) => priority === "high";
